import {
  IEwg,
  IEwgCreateBody,
  IEwgLoginResponse,
} from "../../store/slices/ewg";
import { adminInstance, instance } from "../api";

const ewgLogin = ({
  aktenzeichen,
  kassenzeichen,
}: {
  kassenzeichen: string | number;
  aktenzeichen: string | number;
}) => {
  return instance
    .post<IEwgLoginResponse>("/login/ewg", {
      login: aktenzeichen,
      password: kassenzeichen,
    })
};

const createEwg = (data: IEwgCreateBody) => {
  return instance.post<IEwgLoginResponse>("/ewg", data).then((res) => res.data);
};

const getEwgData = ({
  direction,
  pageSize,
  page,
  searchValue,
  sort,
  status,
  signal,
  endDate,
  startDate,
}: {
  sort?: string;
  direction?: string;
  searchValue?: string;
  page?: number;
  pageSize?: number;
  status?: string[];
  signal?: AbortSignal;
  startDate?: Date | null | string;
  endDate?: Date | null | string;
}) => {
  return adminInstance
    .get<{
      data: IEwg[];
      totalCount: number;
    }>(`/admin/ewg`, {
      params: {
        sort,
        direction,
        searchValue,
        page,
        pageSize,
        status,
        startDate,
        endDate,
      },
      signal,
    })
    .then((res) => res.data);
};

const getEwgById = (id: string) => {
  return adminInstance.get<IEwg>(`admin/ewg/${id}`).then((res) => res.data);
};
const updateAdminEwgDataById = ({
  id,
  status,
}: {
  id: string;
  status: string;
}) => {
  return adminInstance
    .put<IEwg>(`admin/ewg/${id}`, { status })
    .then((res) => res.data);
};

const EWG = {
  get: {
    getEwgData,
    getEwgById,
  },
  post: {
    ewgLogin,
    createEwg,
  },
  put: {
    updateAdminEwgDataById,
  },
};

export default EWG;
